<script setup lang="ts">
import { useCrumbsPublisher } from "@/remote/useCrumbsPublisher";

/**
 * Headless: exists only so `useCrumbsPublisher` runs from a component App mounts AFTER
 * `router.isReady()`. Before the initial navigation resolves `route.params.orgUuid` is empty,
 * which sends useBreadcrumbs down its no-org fallback and publishes the wrong trail.
 */
const props = defineProps<{ host: HTMLElement | null }>();

useCrumbsPublisher(props.host);
</script>

<template><!-- nothing to render; this component only publishes --></template>
